<div class="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white border border-gray-300 rounded-lg shadow-lg p-4 w-80 z-50">
  <form (ngSubmit)="submitElectives()" class="flex flex-col">
    <app-notification-alert [data]="notification"></app-notification-alert>
    <h1 class="font-medium text-center text-lg mb-4">Select Your Electives</h1>
    
    <div class="w-full p-1 mb-4" *ngFor="let elective of electives">
      <label [for]="elective.SubjectGroupID" class="block font-medium mb-1">{{ elective.Label }}</label>
      <select [(ngModel)]="selectedElectives[elective.SubjectGroupID]" [name]="elective.SubjectGroupID" required class="w-full p-1 border border-primary rounded-md focus:outline-none">
        <option disabled value="">Select an elective</option>
        <option *ngFor="let subjectID of elective.SubjectIDs" [value]="subjectID">{{ subjectID }}</option>
      </select>
    </div>
    
    <app-button-primary [disabled]="loading" type="submit">
      Submit
    </app-button-primary>
  </form>
</div>
